import { Button } from '../../components/ui/Button'
import { useAppPath } from '../nav'

type Props = {
  kind: 'deposit' | 'withdrawal'
}

export function LiveRequiredPanel({ kind }: Props) {
  const appPath = useAppPath()
  const isDeposit = kind === 'deposit'

  const title = isDeposit
    ? 'Deposits are available for Live trading accounts.'
    : 'Withdrawals are available for Live trading accounts.'

  const body =
    'Your Demo account uses virtual practice funds only. Open a Live account to continue with real funding.'

  return (
    <div className="cp-live-required" role="status">
      <span className="cp-badge cp-badge--live">Live Account</span>
      <h2>{title}</h2>
      <p>{body}</p>
      <div className="cp-live-required__actions">
        <Button to={appPath('/app/accounts')} variant="primary">
          View Trading Accounts
        </Button>
      </div>
    </div>
  )
}
